module.exports = __webpack_public_path__ + "img/stock0.2cb7b4f7.png";